module.exports = __webpack_public_path__ + "img/card_medicaid_certification.9cd77ce3.svg";